export var menuItems={
  "data": [
    {
      "headTitle1": "Configuración",
      "headTitle2": "Dashboards,Widgets & Layout.",
      "type": "headtitle"
    },
    {
      "path": "/panel/params",
      "title": "Parámetros",
      "icon": "stroke-learning",
      "iconf":"fill-learning",
      "type": "link",
      "active": false
    },
    {
      "title": "Configuración",
      "icon": "stroke-editors",
      "iconf":"fill-editors",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/panel/users",
          "title": "Usuarios",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/roles",
          "title": "Roles & Permisos",
          "type": "link",
          "active":false
        }
      ]
    },
    {
      "title": "Lugares",
      "icon": "stroke-widget",
      "iconf":"fill-widget",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/panel/stores",
          "title": "Tiendas",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/branchs",
          "title": "Sucursales",
          "type": "link",
          "active":false
        }
      ]
    },
    {
      "title": "Personas",
      "icon": "stroke-user",
      "iconf":"fill-user",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/panel/promotors",
          "title": "Promotores",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/managers",
          "title": "Supervisores",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/kams",
          "title": "Kams",
          "type": "link",
          "active":false
        }
      ]
    },
    {
      "headTitle1": "Operaciones",
      "headTitle2": "Ready to use apps",
      "type": "headtitle"
    },
    {
      "path": "/panel/customers",
      "title": "Clientes",
      "icon": "stroke-user",
      "iconf":"fill-user",
      "type": "link",
      "active": false
    },
    {
      "path": "/panel/contracts",
      "title": "Contratos",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
    {
      "title": "Visitas",
      "icon": "stroke-calendar",
      "iconf":"fill-calender",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/panel/visits",
          "title": "Programación",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/importer",
          "title": "Importador",
          "type": "link",
          "active":false
        },
        {
          "path": "/panel/monitor",
          "title": "Monitoreo",
          "type": "link",
          "active":false
        }
      ]
    },
    {
      "headTitle1": "Recursos Humanos",
      "headTitle2": "Ready to use apps",
      "type": "headtitle"
    },
    {
      "path": "/panel/employers",
      "title": "Patrones",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
    {
      "title": "Empleados",
      "icon": "stroke-user",
      "iconf":"fill-user",
      "type": "sub",
      "active":false,
      "children": [
        
          {
            "path": "/panel/employees",
            "title" :"Expedientes",
            "type" : "link",
            "active":false
        
          },
          {
            "path": "/panel/employees/contracts",
            "title" :"Contratos",
            "type" : "link",
            "active":false
        
          }
      ]
    },
    {
      "path": "/panel/salaries",
      "title": "Nómina",
      "icon": "stroke-email",
      "iconf":"fill-email",
      "type": "link",
      "active": false
    },
    {
      "headTitle1": "Resultados",
      "headTitle2": "Ready to use apps",
      "type": "headtitle"
    },
    {
      "path": "/panel/charts",
      "title": "Gráficas",
      "icon": "stroke-charts",
      "iconf":"fill-charts",
      "type": "link",
      "active": false
    },
    {
      "path": "/panel/reports",
      "title": "Reporte de Visitas",
      "icon": "stroke-calendar",
      "iconf":"fill-calender",
      "type": "link",
      "active": false
    },
    {
      "path": "/panel/image-reports",
      "title": "Reporte de Evidencias",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
  ]
}